import { LegalPage, LEGAL_DOCS, type LegalDocKey } from '@gamecodex/portal-ui'

export default function LegalPageRoute({ doc }: { doc: LegalDocKey }) {
  return (
    <div className="app">
      <header className="top">
        <a className="wordmark" href="/">
          RPGreek
        </a>
        <span className="tag">catalog everything. judge everything.</span>
      </header>
      <main className="cols legal-cols">
        <LegalPage doc={LEGAL_DOCS[doc]} portal="RPGreek" />
      </main>
    </div>
  )
}
